import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  markAsExample,
  unmarkAsExample,
  markAsTrainingMaterial,
  unmarkAsTrainingMaterial,
  markAsBenchmark,
  unmarkAsBenchmark,
  openEditTitleDialog,
  closeAssessmentFile,
  reopenAssessmentFile,
  markAsPremium,
  unmarkAsPremium
} from '../../../../../../stores/assessment-file/assessment-file.actions'
import { getAssessmentFile } from '../../../../../../stores/assessment-file/assessment-file.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import { copyExample } from '../../../../../../stores/examples/examples.actions'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { me, id, contributionId, history }) => {
  const assessmentFile = getAssessmentFile(state)
  const user = me.account
  return {
    id: assessmentFile.id,
    title: assessmentFile.title,
    description: assessmentFile.context,
    example: assessmentFile.example,
    moderation_type: assessmentFile.moderation_type,
    judgement: assessmentFile.judgement,
    trainingMaterial: assessmentFile.training_material,
    canMarkAsExample: assessmentFile.policy.can_mark_as_example,
    canMarkAsTrainingMaterial: user.policy.can_mark_as_exemplar, // we will need a dedicated BE policy
    canUpdate: assessmentFile.policy && assessmentFile.policy.can_update,
    canClose: assessmentFile.policy && assessmentFile.policy.can_close,
    isClosed: assessmentFile.closed,
    canMarkAsBenchmark:
      assessmentFile.policy && assessmentFile.policy.can_mark_as_benchmark,
    benchmarked: assessmentFile.benchmarked,
    canManageAFs: user.policy && user.policy.can_manage_assessment_files,
    canSeeContextMenu:
      user.policy &&
      (user.policy.can_manage_assessment_files ||
        user.policy.can_mark_as_benchmark ||
        user.policy.can_close ||
        user.policy.can_update ||
        user.policy.can_mark_as_exemplar),
    premium: assessmentFile.premium,
    canMarkAsPremium: user.policy.can_mark_assessment_file_as_premium
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onMarkAsExample: id => dispatch(markAsExample(id)),
  onUnmarkAsExample: id => dispatch(unmarkAsExample(id)),
  onMarkAsTrainingMaterial: id => dispatch(markAsTrainingMaterial(id)),
  onUnmarkAsTrainingMaterial: id => dispatch(unmarkAsTrainingMaterial(id)),
  onMarkAsBenchmark: id => dispatch(markAsBenchmark(id)),
  onUnmarkAsBenchmark: id => dispatch(unmarkAsBenchmark(id)),
  onOpenEditTitleDialog: (id, title, description, moderation_type, judgement) =>
    dispatch(
      openEditTitleDialog(id, title, description, moderation_type, judgement)
    ),
  onClose: id => dispatch(closeAssessmentFile(id)),
  onReopen: id => dispatch(reopenAssessmentFile(id)),
  onCopy: id => {
    return dispatch(copyExample(id)).then(() =>
      ownProps.history.push('/my-files')
    )
  },
  onMarkAsPremium: id => dispatch(markAsPremium(id)),
  onUnmarkAsPremium: id => dispatch(unmarkAsPremium(id))
})

export default withRouter(
  withMe(
    connect(
      mapStateToProps,
      mapDispatchToProps,
      mergeProps
    )(ContextMenu)
  )
)
